import React from "react";
import { FaCheck } from "react-icons/fa6";
import styles from "../transfer.module.css";
import clsx from "clsx"; // install if not already: npm i clsx
const RadioButton = ({ selectedId, currentId, onStudentSelection, row }) => {
  const isSelected = selectedId === currentId;
  return (
    <div
      className={clsx(
        styles.radioBase,
        isSelected ? styles.radioActive : styles.radioInactive
      )}
      onClick={() => onStudentSelection(row)}
    >
      {isSelected && <FaCheck height={6} width={6} color="white" />}
    </div>
  );
};


export default RadioButton